export default "__VITE_ASSET__Wuewv86c__"